import { jsx as _jsx } from "react/jsx-runtime";
import { Select as MuiSelect, useForkRef } from '@mui/material';
import { forwardRef } from 'react';
import { t } from '@/core/localization';
import { SelectPlaceholder } from './Select.styled';
// TODO: refactor
/**
 * **Global Parts** Select.
 *
 * Uses *MuiSelect* under the hood and handles console error when 'undefined' is passed as *value*.
 *
 * It also has the `placeholder` property that adds placeholder functionality.
 *
 * @param strict makes warning enabled again on `undefined`.
 * @param placeholder adds placeholder functionality.
 *
 * `ref` is forwarded to MUI `inputRef`, whose handle has a working `focus()`, so react-hook-form can focus the field on
 * a validation error. The root `div` that a plain `ref` would get is not focusable.
 */
const SelectBase = ({ strict = false, value, placeholder, inputRef, ...props }, ref) => {
    const forkedInputRef = useForkRef(inputRef, ref);
    // `selectedValue === ''` check is not enough, it doesn't handle nullish value. `!selectedValue `check is used here.
    const isValueEmpty = (selectedValue) => (props.multiple && !selectedValue?.length) || (!props.multiple && !selectedValue);
    const renderPlaceholderValue = (_selected) => {
        // If we have decided to use full object with fields instead of an ID only, as described in big comment below (above
        // `renderValue` prop), then we should uncomment this and use it.
        // if (isValueEmpty(selected)) {
        return _jsx(SelectPlaceholder, { children: placeholder === true ? t('select.placeholder') : placeholder });
        // }
        // return selected as React.ReactNode;
    };
    // Style overrides are necessary inside the component, but not global, since MuiMenu is used not only in Select.
    return (_jsx(MuiSelect, { variant: "outlined", displayEmpty: placeholder ? true : props.displayEmpty, 
        // `&& isValueEmpty(value)` check has to be used here, instead of being used inside `renderPlaceholderValue`
        // function, because when some value is selected the component will show it's `id` instead of `label`, when it
        // returns `selected` value. MUI Select component probably expects not only an ID of an item but an item itself.
        // May be if we could pass not only the ID of an item but an item itself, then we would be able to use
        // `return selected` inside `renderValue` function.
        renderValue: placeholder && isValueEmpty(value) ? renderPlaceholderValue : props.renderValue, ...props, inputRef: forkedInputRef, 
        // In case `||` is used instead of `??` nullish value (`0`, for example) is count as null and it is not working
        // (important for enums).
        // @ts-ignore [] is old bugfix but it is fixed in Feature #13.
        value: strict ? value : props.multiple ? (value ?? []) : (value ?? '') }));
};
// `forwardRef` drops the generic, so the cast restores `Select<Value>`.
const Select = forwardRef(SelectBase);
export { Select };
